import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { triggerNotification } from "../../component/message/Msg";
import config from "../../config";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import Rating from "../../component/rating/Rating";
import StarRatings from "react-star-ratings";
import Swal from "sweetalert2";
import noImg from "../../assetsCon/assets/images/noImg.png";
import moment from "moment";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewDoubts = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [doubts, setDoubts] = useState([]);
  const token = config.token;
  const navigate = useNavigate();

  //  ------For TableViewer ------
  const doubtsRef = useRef([]);
  doubtsRef.current = doubts;
  const [rowData, setRowData] = useState([]);
  const [solutionFiles, setSolutionFiles] = useState([]);
  const [cacheInfo, setCacheInfo] = useState({
    id: "",
    rowIndex: "",
    solTxt: "",
    solFile: "",
    isDoubt: false,
  });
  //  ------For TableViewer ------

  const getDoubts = async () => {
    setLoading(true);
    fetch(`${config.host_url}doubt/${decodeURIComponent(atob(id))}`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setDoubts(data.data);

        //  ------For TableViewer ------
        const doubtsData = data.data.map((dbt) => ({
          first_name: dbt.first_name,
          last_name: dbt.last_name,
          solution_msg: dbt.solution_msg,
          solution: dbt.solution,
          msg: dbt.msg,
          file: dbt.file,
          status: dbt.status,
          idNumber: dbt.did,
        }));
        setRowData(doubtsData);
        //  ------For TableViewer ------

        setLoading(false);
      });
  };
  useEffect(() => {
    getDoubts();
  }, [token]);

  // ------------------------------------------------------------------ Delete class -----------------------------------------------------D
  //   const handleDeleteBtn = (id, i) => {
  //     Swal.fire({
  //       title: "Are you sure?",
  //       text: "You are about to delete class. Are you sure you want to proceed?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "Yes, delete it!",
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         handleDelete(id, i);
  //       }
  //     });
  //     //Confirm delete
  //     const handleDelete = (id, i) => {
  //       fetch(`${config.host_url}classes/${id}`, {
  //         method: "DELETE",
  //         headers: {
  //           "Content-Type": "application/json",
  //           token: token,
  //         },
  //       })
  //         .then(function (response) {
  //           // console.log("Response:", response);
  //           return response.json();
  //         })
  //         .then(function (data) {
  //           console.log("Data:", data);

  //           if (data.status === 200) {
  //             triggerNotification("success", "Class deleted successfully");

  //             //  ------For TableViewer ------
  //             const updatedClasses = [...doubtsRef.current];
  //             updatedClasses.splice(i, 1);
  //             setDoubts(updatedClasses);

  //             const doubtsData = updatedClasses.map((dbt) => ({
  //               class: dbt.class,
  //               idNumber: dbt.classid,
  //             }));
  //             setRowData(doubtsData);
  //             //  ------For TableViewer ------
  //           } else if (data.status === 404) {
  //             triggerNotification("error", "Class not found");
  //           } else if (data.status === 401) {
  //             triggerNotification("error", "Unauthenticated User");
  //           } else {
  //             triggerNotification(
  //               "error",
  //               "Internal server error, Please try after some time!"
  //             );
  //           }
  //         })
  //         .catch(function (error) {
  //           console.error("Error:", error);
  //           triggerNotification("error", "Error deleting Class");
  //         });
  //     };
  //   };

  // ------------------------------------------------------------------ edit class -----------------------------------------------------U
  //   const handleEditBtn = (id) => {
  //     navigate(`/addclass/${btoa(encodeURIComponent(id))}`);
  //   };

  //  ------For TableViewer ------

  const submitSolution = () => {
    try {
      if (
        (cacheInfo.solFile === "" || cacheInfo.solFile === undefined) &&
        (cacheInfo.solTxt === "" || cacheInfo.solTxt === undefined)
      ) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      const formData = new FormData();
      formData.append("solution_file", cacheInfo.solFile);
      formData.append("msg", cacheInfo.solTxt);
      fetch(`${config.host_url}doubt/solution/${cacheInfo.id}`, {
        method: "POST",
        headers: {
          token: token,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // class created successfully
            triggerNotification(
              "success",
              "Solution file submitted successfully."
            );
            getDoubts();
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error submitting evaluated copy", error);
      triggerNotification(
        "error",
        "An error occurred while submitting the evaluated copy."
      );
    }
  };

  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "Student Name",
      field: "first_name",
      width: 250,
      cellRenderer: (params) => (
        <p className=" ">
          {params.data.first_name + " " + params.data.last_name}
        </p>
      ),
    },
    {
      headerName: "Message",
      field: "msg",
      width: 370,
      cellRenderer: (params) => (
        <p>
          {params.data.msg.length > 43 ? (
            <div className="flex">
              {params.data.msg.slice(0, 35) + ".."}
              <div
                data-bs-toggle="modal"
                data-bs-target="#viewSolModal"
                onClick={() => {
                  setCacheInfo({
                    solTxt: params.data.msg,
                    solFile: "",
                    id: params.data.idNumber,
                    rowIndex: params.rowIndex,
                    isDoubt: true,
                  });
                }}
              >
                <span className="text-blue-600">{".  Read More"}</span>
              </div>
            </div>
          ) : (
            params.data.msg
          )}
        </p>
      ),
    },
    {
      headerName: "Doubt File",
      field: "file",
      width: 150,
      cellRenderer: (params) => (
        <div className="flex h-full justify-center ">
          {params.data.file ? (
            <h6 className="text-slate-950/50 my-auto">
              <a
                href={params.data?.file}
                target="_blank"
                rel="noopener noreferrer"
                className=" border px-1 bg-gray-100 rounded shadow-sm text-blue-400"
              >
                Open Doubt file
              </a>
            </h6>
          ) : (
            " - "
          )}
        </div>
      ),
    },
    {
      headerName: "Status",
      field: "status",
      width: 150,
      cellRenderer: (params) => (
        <p>{params.data.status === 0 ? "Pending" : "Solved"}</p>
      ),
    },
    {
      headerName: "Solution",
      field: "solution",
      width: 350,
      cellRenderer: (params) => (
        <>
          {params.data.status === 0 ? (
            <button
              className=" btn btn-secondary"
              data-bs-toggle="modal"
              data-bs-target="#addSolModal"
              onClick={() => {
                setCacheInfo({
                  solTxt: "",
                  solFile: "",
                  id: params.data.idNumber,
                  rowIndex: params.rowIndex,
                  isDoubt: false,
                });
              }}
            >
              Upload Solution
            </button>
          ) : (
            <>
              <button
                className=" btn btn-secondary"
                data-bs-toggle="modal"
                data-bs-target="#viewSolModal"
                onClick={() => {
                  setCacheInfo({
                    solTxt: params.data.solution_msg,
                    solFile: params.data.solution,
                    id: params.data.idNumber,
                    rowIndex: params.rowIndex,
                    isDoubt: false,
                  });
                }}
              >
                View Solution
              </button>
            </>
          )}
        </>
      ),
    },
  ];

  //  ------For TableViewer ------
  useEffect(() => {
    console.log("cacheInfo: ", cacheInfo);
  }, [cacheInfo]);
  return (
    <>
      <Breadcrumb
        txt="Manage Course"
        subpath={["View Courses", "View Doubts"]}
        url={["/viewcourses"]}
      />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Doubts - Pending</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="justify-center px-3 pb-3 row  select-none">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData.filter((row) => row.status !== 1)}
                colDefs={colDefs}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Doubts - Solved</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="justify-center px-3 pb-3 row  select-none">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData.filter((row) => row.status === 1)}
                colDefs={colDefs}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>

      {/* //----------------------------------------------- add sol popup ----------------------------- */}
      <div
        className="modal "
        id={`addSolModal`}
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-simple  modal-lg modal-add-new-cc">
          <div className="modal-content pb-2">
            <div className="modal-body p-md-0">
              <h5 className="card-header p-0 pb-3">Upload Solution</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              <div className="row border rounded p-2  mb-4 ">
                <div className=" mt-2">
                  <label htmlFor="fl" className="ml-2">
                    Solution File
                  </label>
                  <input
                    type="file"
                    className="form-control "
                    name={`fl`}
                    id={`fl`}
                    onChange={(e) => {
                      const selectedFiles = e.target.files;
                      setCacheInfo((prevData) => ({
                        ...prevData,
                        solFile: selectedFiles[0],
                      }));
                    }}
                  />

                  <div className="form-floating form-floating-outline mt-4 mb-4 ">
                    <input
                      type="text"
                      className="form-control "
                      id="txt"
                      placeholder="Solution Message"
                      value={cacheInfo.solTxt}
                      onChange={(e) => {
                        const value = e.target.value;
                        setCacheInfo((prevData) => ({
                          ...prevData,
                          solTxt: value,
                        }));
                      }}
                    />
                    <label htmlFor="txt">Solution Message</label>
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary mb-2"
                    data-bs-dismiss="modal"
                    onClick={() => submitSolution()}
                  >
                    submit
                  </button>
                </div>
              </div>
              <div className="d-flex justify-content-end py-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* //----------------------------------------------- View sol popup ----------------------------- */}
      <div
        className="modal "
        id={`viewSolModal`}
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-simple  modal-lg modal-add-new-cc">
          <div className="modal-content pb-2">
            <div className="modal-body p-md-0">
              <h5 className="card-header p-0 pb-3">
                View{" "}
                {cacheInfo.isDoubt === true ? " Doubt Message" : " Solution"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              <div className="row border rounded p-2  mb-4 ">
                <div className="py-3">
                  {cacheInfo.solTxt && (
                    <>
                      <p>{cacheInfo.solTxt}</p>
                    </>
                  )}
                  {cacheInfo.solFile && (
                    <h6 className="text-slate-950/50 my-auto">
                      <a
                        href={cacheInfo.solFile}
                        target="_blank"
                        rel="noopener noreferrer"
                        className=" border px-1 bg-gray-100 rounded shadow-sm text-blue-400"
                      >
                        Open Solution File
                      </a>
                    </h6>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-end py-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDoubts;
